import React from "react";
import { HashLink as Link } from 'react-router-hash-link';
import logo from "../../assets/images/logo.png";
import "./styles.scss";

class Header extends React.Component {
	constructor(props) {
	  super(props);
	  this.state = {
		isOpen: false,
		isOnTop: false,
	  };
	  this.isOnTop = this.isOnTop.bind(this);
	  this.handleTogglerClick = this.handleTogglerClick.bind(this);
	  this.handleScroll = this.handleScroll.bind(this);
	}

	componentDidMount() {
		this.isOnTop();
		window.addEventListener('scroll', this.handleScroll, { passive: true });
	}

	componentWillUnmount() {
	  window.removeEventListener('scroll', this.handleScroll);
	}
  
	handleScroll(event) {
		this.isOnTop();
		this.setState({isOpen: false});
	}

	handleTogglerClick() {
		this.setState({isOpen: !this.state.isOpen});
	}

	isOnTop() {
		this.setState({
			isOnTop: !!(window.pageYOffset === 0)
		});
	}

	render() {
		const { isOpen, isOnTop } = this.state;

		return(
			<header className={`header ${isOnTop ? "-top" : "-not-top"} ${isOpen ? "-open" : ""}`}>
				<nav className="nav header__wrapper container">
					<Link smooth to="/#home" className="header__logo-link">
						<img src={logo} alt="" className="header__logo"/>
					</Link>
					<button onClick={this.handleTogglerClick} className="nav__toggler">
						<div className="nav__toggler__icon">
							<span></span>
							<span></span>
							<span></span>
						</div>
					</button>
					<ul className="list">
						<li className="list__item">
							<Link to="/#home" className="list__link">Home</Link>
						</li>
						<li className="list__item">
							<Link to="/#servicios" className="list__link">Servicios</Link>
						</li>
						<li className="list__item">
							<Link to="/#nosotros" className="list__link">Nosotros</Link>
						</li>
						<li className="list__item">
							<Link to="/#contacto" className="list__link">Contacto</Link>
						</li>
						<li className="list__item">
							<a href="http://dorronsoro.biodatasa.com.ar/" target="_blank" rel="noopener noreferrer" className="list__link -highlighted">Resultados</a>
						</li>
					</ul>
				</nav>
			</header>
		);
	}
}

export default Header;